import { Output, Input, ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { BaseComponent } from '../base.component';

/**
 * Component.
 */
@Component({
    selector: 'imprint',
    template: `
        <div style="padding-bottom: 10px; text-align: center">
            <img height="100" alt="Logo" src="assets/images/logo_icon.svg" />
            <i18n-selector></i18n-selector>
        </div>
		<div style="box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19); padding: 5px 10px 5px 10px">
            <h1>{{v('imprint')}}</h1>
            <p>
				<strong>{{'TENANT_NAME' | env}}</strong><br /> 
                Alte Rhinstraße 4<br />
                12681 Berlin<br />
                www.menuepartner.de<br />
			</p>
            <p>
                <strong>Kundencenter</strong><br /> 
				Telefon: {{'TENANT_SVC_PHONE' | env}}<br /> 
				Fax: {{'TENANT_SVC_FAX' | env}}<br />
                E-Mail: {{'TENANT_SVC_EMAIL' | env}}<br />
			</p>
            <p>
                <strong>Geschäftsführer</strong><br /> 
                Markus Lang<br />
                Dako Dombrowsky<br />
			</p>
            <p>
                <strong>Handelsregister</strong><br /> 
                AG Berlin-Charlottenburg, HRA 58302 B<br />
			</p>
            <p>
                <strong>Umsatzsteuer-ID</strong><br /> 
                DE 165549349<br />
			</p>
            <p>
                <strong>Konzept/Gestaltung/Programmierung</strong><br /> 
                food safety qualITy GmbH<br />
			</p>
            <p>
                <strong>Online-Streitbeilegung gem. Art. 14 Abs. 1 ODR-VO</strong><br /> 
                Die Europäische Kommission stellt zur Online-Streitbeilegung eine Plattform im Internet unter: https://ec.europa.eu/consumers/odr/ bereit. Wir sind weder bereit noch verpflichtet, an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.<br />
			</p>
        </div>
        <div style="padding-top: 15px; text-align: center;">
            <span><strong>&#169; 2014–{{year}} food safety qualITy GmbH</strong><br /></span>
            <span><strong>Alle Rechte vorbehalten.</strong></span>
        </div>
		`
})
export class ImprintComponent extends BaseComponent {
    year = new Date().getFullYear()
}

